import { gql, type TypedDocumentNode } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Grid } from '@sorare/core/src/atoms/layout/grid';
import { HeadlineM } from '@sorare/core/src/atoms/typography';

import { PackWithBuyButton } from '#src/components/commonCard/BuyPacks/PackWithBuyButton/index.tsx';

import type { FindItInCardPacks_cardPack } from './__generated__/index.graphql.ts';

const CardPackWrapper = styled(Vertical)`
  position: relative;
  background: var(--c-nl-200);
  border-radius: var(--unit);
  border: 1px solid var(--c-nd-50);
  padding: var(--unit);
`;

type Props = {
  cardPacks: FindItInCardPacks_cardPack[];
};

export const FindItInCardPacks = ({ cardPacks }: Props) => {
  if (!cardPacks.length) {
    return null;
  }

  return (
    <Vertical>
      <HeadlineM className="text-center">
        <FormattedMessage
          id="EmptyCollectionSlotContent.packs.title"
          defaultMessage="Try to find it in these packs:"
        />
      </HeadlineM>
      <Grid>
        {cardPacks.map(cardPack => (
          <CardPackWrapper key={cardPack.slug} center>
            <PackWithBuyButton
              cardPack={cardPack}
              cardPackGroupId={cardPack.cardPackGroup?.id || ''}
            />
          </CardPackWrapper>
        ))}
      </Grid>
    </Vertical>
  );
};

FindItInCardPacks.fragments = {
  cardPack: gql`
    fragment FindItInCardPacks_cardPack on CardPack {
      slug
      pictureUrl
      currency
      price
      cardPackGroup {
        id
      }
      ...PackWithBuyButton_cardPack
    }
    ${PackWithBuyButton.fragments.cardPack}
  ` as TypedDocumentNode<FindItInCardPacks_cardPack>,
};
